/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Final_TitleInputs */

const en_mk_final_title = /** @type {(inputs: Mk_Final_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your next step starts here`)
};

const id_mk_final_title = /** @type {(inputs: Mk_Final_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langkah berikutnya dimulai di sini`)
};

/**
* | output |
* | --- |
* | "Your next step starts here" |
*
* @param {Mk_Final_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_final_title = /** @type {((inputs?: Mk_Final_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Final_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_final_title(inputs)
	return en_mk_final_title(inputs)
});